import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { Box } from 'wt-ui';
import RowHeader from './RowHeader';
import RowContent from './RowContent';
import RowContentPreview from './RowContentPreview';

import heap from '../../services/heap';

const CalendarRow = ({ event }) => {
  const [isOpen, setIsOpen] = useState(false); // !!event.children
  const style = {
    borderBottom: '1px solid grey',
  };
  if (isOpen && !event.children) {
    // style.boxShadow = '0 0 10px #a6a6a6';
    style.boxShadow = 'rgb(166, 166, 166) 1px 4px 6px -2px';
    delete style.borderBottom;
  }

  const toggleContent = () => {
    heap.track('Calendar_ToggleRow');
    setIsOpen(!isOpen);
  };

  return (
    <Box background="transparent" pad="small" style={style}>
      <RowHeader toggleContent={toggleContent} event={event} />
      {isOpen ? <RowContent event={event} /> : <RowContentPreview event={event} toggleContent={toggleContent} />}
    </Box>
  );
};

export default CalendarRow;
